import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Box, Grid, Stack, useMediaQuery, useTheme } from '@mui/material';

import { AppRadioBox } from 'shared/components/AppComponents';

export default function MissingList(props: ListProps): React.ReactElement {
    const {
        category,
        isSendToRework,

        onCheckedSendToRework,
    } = props;
    const theme = useTheme();
    const match = useMediaQuery(theme.breakpoints.up('md'));

    const handleRadioCheckbox = React.useCallback(() => {
        if (typeof onCheckedSendToRework === 'function') {
            onCheckedSendToRework(isSendToRework);
        }
    }, [isSendToRework, onCheckedSendToRework]);
    return (
        <ListItem>
            <Grid container spacing={2} className="categorization-container">
                <Grid item xs={12} md={12} lg={12} className="content-list">
                    <Stack
                        direction={match ? 'row' : 'column'}
                        spacing={1}
                        display="flex"
                        flexGrow={1}
                    >
                        <Box className="categorization-checkbox">
                            <AppRadioBox
                                checked={isSendToRework}
                                color="primary"
                                value="testt2"
                                onChange={handleRadioCheckbox}
                                label="Send to Rework"
                            />
                        </Box>

                        <Grid
                            container
                            direction="row"
                            className="content-container"
                        >
                            <Grid
                                item
                                xs={12}
                                md={8}
                                className="list-container"
                            >
                                <ListItemText
                                    className="capitalize"
                                    primary="Category"
                                    secondary={category}
                                />
                            </Grid>
                        </Grid>
                    </Stack>
                </Grid>
            </Grid>
        </ListItem>
    );
}
